import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@material-ui/core';
import { getConsolePreferenceAllowPickupWhenBotInteraction } from '@src/selectors/preferences';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

// eslint-disable-next-line no-shadow
export const enum TakeChatFromCallStatus {
  'OPENED' = 'OPENED',
  'BOT_CHATTING' = 'BOT_CHATTING',
  'PICKED_UP' = 'PICKED_UP',
}

interface StartContactCallFromBotDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  status: TakeChatFromCallStatus;
}

const StartContactCallFromBotDialog: React.FC<
  StartContactCallFromBotDialogProps
> = ({ open, onClose, onConfirm, status }) => {
  const { formatMessage } = useIntl();

  const canTakeChatFromBot = useSelector(
    getConsolePreferenceAllowPickupWhenBotInteraction
  );

  const canTakeChat =
    status === TakeChatFromCallStatus.OPENED || canTakeChatFromBot;

  const contentText = formatMessage({
    id: `CallPermission.takeChatFromTray.${status}${
      canTakeChat ? '' : '.permissionError'
    }.content`,
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>
        {formatMessage({
          id: `CallPermission.takeChatFromTray.${status}.title`,
        })}
      </DialogTitle>
      <DialogContent
        dangerouslySetInnerHTML={{
          __html: contentText,
        }}
      />

      <Divider style={{ marginBottom: '40px' }} />

      <DialogActions>
        {!canTakeChat ? (
          <Button onClick={onClose} color="primary" variant="contained">
            {formatMessage({
              id: 'CallPermission.takeChatFromTray.Option.Accept',
            })}
          </Button>
        ) : (
          <>
            <Button onClick={onClose} color="primary" variant="outlined">
              {formatMessage({
                id: 'CallPermission.takeChatFromTray.Option.No',
              })}
            </Button>
            <Button onClick={onConfirm} color="primary" variant="contained">
              {formatMessage({
                id: 'CallPermission.takeChatFromTray.Option.Yes',
              })}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default StartContactCallFromBotDialog;
